import { FormControl, FormGroup } from '@angular/forms';

import { InsurancePolicyForm } from './insurance-policy-form';
import { SiteForm } from './site-form';

export class InsurancePolicySiteForm extends FormGroup<{
  id: FormControl<number | undefined>;
  InsurancePolicyId: FormControl<number | undefined>;
  SiteId: FormControl<number | undefined>;

  Site?: SiteForm;
  InsurancePolicyForm?: InsurancePolicyForm;
}> {
  constructor() {
    super({
      id: new FormControl<undefined | number>(undefined, { nonNullable: true }),
      InsurancePolicyId: new FormControl<undefined | number>(undefined, {
        nonNullable: true
      }),
      SiteId: new FormControl<undefined | number>(undefined, {
        nonNullable: true
      })
    });
  }
}
